import { render, staticRenderFns } from "./Cooperate.vue?vue&type=template&id=9904cae6&scoped=true"
import script from "./Cooperate.vue?vue&type=script&lang=js"
export * from "./Cooperate.vue?vue&type=script&lang=js"
import style0 from "./Cooperate.vue?vue&type=style&index=0&id=9904cae6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9904cae6",
  null
  
)

export default component.exports